import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import {
  ClalPage,
  EmptyLandingsPage,
  HerzliyaPage,
  LandingPageByRouteCompanyId,
  LandingPageByRouteCompanyName,
  NotFoundLandingPage,
  NvidiaShuttlePage,
  TnufaPage,
  WestNegevPage,
  WixPage,
} from "@ryde/pages-landings";
import { Log } from "@ryde/shared";
import {
  getLandingPathByCompanyId,
  LandingCompanyIdEnum,
} from "@ryde/utils-landings";

Log.debug(
  "[ROUTER] NvidiaShuttle path:",
  `/c/${LandingCompanyIdEnum.NvidiaShuttle}`,
);
Log.debug("[ROUTER] All landing company IDs:", LandingCompanyIdEnum);

export const appLandingRouter = () =>
  createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route index element={<EmptyLandingsPage />} />

        {/* generic route /c/1/landing */}
        <Route
          path="/c/:companyId/landing/*"
          element={<LandingPageByRouteCompanyId />}
        />

        {/* render only when company map is ready */}

        <Route
          path="/landing/:companyName/*"
          element={<LandingPageByRouteCompanyName />}
        />

        {/**********************************************************************/}
        {/****************************STATIC PAGES******************************/}
        {/**********************************************************************/}

        {/* HerzliyaPage => fully customizable route /c/:{companyId}*/}
        <Route
          path={`/c/${LandingCompanyIdEnum.Herzliya}`}
          element={<HerzliyaPage companyId={LandingCompanyIdEnum.Herzliya} />}
        />

        {/* HerzliyaPage => fully customizable route /:{companyName} */}
        <Route
          path={`/${getLandingPathByCompanyId(LandingCompanyIdEnum.Herzliya)}`}
          element={<HerzliyaPage companyId={LandingCompanyIdEnum.Herzliya} />}
        />

        {/* ClalPage => fully customizable route /c/:{companyId}*/}
        <Route
          path={`/c/${LandingCompanyIdEnum.Clal}`}
          element={<ClalPage companyId={LandingCompanyIdEnum.Clal} />}
        />

        {/* ClalPage => fully customizable route /:{companyName} */}
        <Route
          path={`/${getLandingPathByCompanyId(LandingCompanyIdEnum.Clal)}`}
          element={<ClalPage companyId={LandingCompanyIdEnum.Clal} />}
        />
        {/* TnufaPage => fully customizable route /c/:{companyId}*/}
        <Route
          path={`/c/${LandingCompanyIdEnum.Tnufa}`}
          element={<TnufaPage companyId={LandingCompanyIdEnum.Tnufa} />}
        />

        {/* Tnufa => fully customizable route /:{companyName} */}

        {/* WestNegevPage => fully customizable route /c/:{companyId}*/}
        <Route
          path={`/c/${LandingCompanyIdEnum.WestNegev}`}
          element={<WestNegevPage companyId={LandingCompanyIdEnum.WestNegev} />}
        />

        {/* WestNegevPage => fully customizable route /:{companyName} */}
        <Route
          path={`/${getLandingPathByCompanyId(LandingCompanyIdEnum.WestNegev)}`}
          element={<WestNegevPage companyId={LandingCompanyIdEnum.WestNegev} />}
        />
        <Route
          path={`/${getLandingPathByCompanyId(LandingCompanyIdEnum.Tnufa)}`}
          element={<TnufaPage companyId={LandingCompanyIdEnum.Tnufa} />}
        />

        {/* NvidiaShuttlePage => fully customizable route /c/:{companyId}*/}
        <Route
          path={`/c/${LandingCompanyIdEnum.NvidiaShuttle}`}
          element={
            <NvidiaShuttlePage companyId={LandingCompanyIdEnum.NvidiaShuttle} />
          }
        />

        {/* NvidiaShuttlePage => fully customizable route /:{companyName} */}
        <Route
          path={`/${getLandingPathByCompanyId(LandingCompanyIdEnum.NvidiaShuttle)}`}
          element={
            <NvidiaShuttlePage companyId={LandingCompanyIdEnum.NvidiaShuttle} />
          }
        />

        {/* WixPage => fully customizable route /c/:{companyId}*/}
        <Route
          path={`/c/${LandingCompanyIdEnum.Wix}`}
          element={<WixPage companyId={LandingCompanyIdEnum.Wix} />}
        />

        {/* WixPage => fully customizable route /:{companyName} */}
        <Route
          path={`/${getLandingPathByCompanyId(LandingCompanyIdEnum.Wix)}`}
          element={<WixPage companyId={LandingCompanyIdEnum.Wix} />}
        />

        {/**********************************************************************/}
        {/****************************END STATIC PAGES*************************/}
        {/*********************************************************************/}

        {/* generic route by company name /landing/unipharm */}
        <Route path="*" element={<NotFoundLandingPage />} />
      </>,
    ),
  );
